import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../config/routes';
import { useBookingStore } from '../store/bookingStore';
import { useTicketStore } from '../store/ticketStore';

/**
 * Hook personalizado para navegación
 * Similar a un NavigationService en Angular
 * 
 * Centraliza toda la lógica de navegación de la app
 */
export const useNavigation = () => {
  const navigate = useNavigate();
  const clearBooking = useBookingStore((state) => state.clearBooking);

  const goToHome = () => {
    navigate(ROUTES.HOME);
  };

  const goToLogin = () => {
    navigate(ROUTES.LOGIN);
  };

  const goToSearch = () => {
    navigate(ROUTES.SEARCH);
  };

  const goToPassengers = () => {
    navigate(ROUTES.PASSENGERS);
  };

  const goToPayment = () => {
    navigate(ROUTES.PAYMENT);
  };

  const goToTicket = () => {
    navigate(ROUTES.TICKET);
  };

  const goToProfile = () => {
    navigate(ROUTES.PROFILE);
  };

  const goToSettings = () => {
    navigate(ROUTES.SETTINGS);
  };

  const goToMyTickets = (tab?: 'active' | 'history') => {
    if (tab) {
      const setTab = useTicketStore.getState().setMyTicketsInitialTab;
      setTab(tab);
    }
    navigate(ROUTES.MY_TICKETS);
  };

  const goToTicketDetail = (ticketId: string) => {
    navigate(`${ROUTES.TICKET_DETAIL}/${ticketId}`);
  };

  const goToAccount = () => {
    navigate(ROUTES.ACCOUNT);
  };

  const goBack = () => {
    navigate(-1);
  };

  const goToHomeAndClearBooking = () => {
    clearBooking();
    navigate(ROUTES.HOME);
  };

  return {
    goToHome,
    goToLogin,
    goToSearch,
    goToPassengers,
    goToPayment,
    goToTicket,
    goToProfile,
    goToSettings,
    goToMyTickets,
    goToTicketDetail,
    goToAccount,
    goBack,
    goToHomeAndClearBooking,
  };
};